import React from 'react';
import './DecisionTraceSummary.css';

const ACTION_LABELS = {
  draft_connection_request: 'Connectieverzoek voorbereiden',
  draft_linkedin_message: 'LinkedIn-bericht voorbereiden',
  draft_email: 'E-mail voorbereiden',
  manual_review: 'Handmatige review',
  wait: 'Wachten',
  sendConnectionRequest: 'LinkedIn connectieverzoek',
  sendMessage: 'LinkedIn-bericht',
  sendEmail: 'E-mail',
};

function percent(value) {
  const number = Number(value);
  return Number.isFinite(number) ? `${Math.round(number * 100)}%` : '—';
}

function labelAction(value) {
  return ACTION_LABELS[value] || String(value || '—').replace(/_/g, ' ');
}

export default function DecisionTraceSummary({ trace }) {
  if (!trace) return null;
  const planner = trace.planner || {};
  const ai = trace.ai || {};
  const actionDecision = ai.nextBestAction || null;
  const guardrails = trace.guardrails || {};
  const final = trace.final || {};
  const decisionChanged = actionDecision?.changed === true;

  return (
    <details className="agent-decision-trace">
      <summary>
        <span>Waarom koos de agent dit?</span>
        <small>
          {decisionChanged
            ? 'AI koos een andere veilige vervolgstap dan de planner-default'
            : guardrails.result === 'modified'
              ? 'AI-keuze aangepast door veilige uitvoerlogica'
              : 'AI + guardrails akkoord'}
        </small>
      </summary>
      <div className="agent-decision-trace-grid">
        <section>
          <span className="agent-decision-step">1 · Doel & planner</span>
          <strong>{trace.goal?.subgoal ? String(trace.goal.subgoal).replace(/_/g, ' ') : labelAction(planner.action)}</strong>
          <p>{planner.reason || 'De planner bepaalde de volgende veilige stap binnen het campagnedoel.'}</p>
          {planner.qualificationScore != null && <small>Planner qualification: {Math.round(Number(planner.qualificationScore))}/100</small>}
        </section>
        <section>
          <span className="agent-decision-step">2 · AI next-best action</span>
          {actionDecision ? <>
            <strong>{labelAction(actionDecision.selectedAction)}{actionDecision.selectedChannel ? ` · ${actionDecision.selectedChannel}` : ''}</strong>
            <p>{actionDecision.reason || 'De AI rangschikte uitsluitend de vooraf veilig verklaarde kandidaat-acties.'}</p>
            <small>
              Planner-default: {labelAction(actionDecision.plannerAction)}{actionDecision.plannerChannel ? ` · ${actionDecision.plannerChannel}` : ''}
              {' · '}confidence {percent(actionDecision.confidence)}
              {actionDecision.changed ? ' · gewijzigd' : ' · behouden'}
            </small>
          </> : <>
            <strong>{labelAction(ai.recommendedAction)} · {ai.recommendedChannel || 'geen kanaal'}</strong>
            <p>{ai.reason || 'De AI beoordeelde lead-fit en de aanbevolen vervolgstap.'}</p>
            <small>Lead fit {ai.leadFit ?? '—'}/100 · confidence {percent(ai.confidence)}</small>
          </>}
        </section>
        <section>
          <span className="agent-decision-step">3 · Guardrails</span>
          <strong>{guardrails.result === 'modified' ? 'Keuze aangepast' : 'Toegestaan'}</strong>
          <p>
            {guardrails.channelModified
              ? `AI adviseerde ${ai.recommendedChannel || 'een ander kanaal'}; de veilige uitvoerlaag koos ${guardrails.selectedChannel || final.channel || 'geen kanaal'}.`
              : `Kanaal ${guardrails.selectedChannel || final.channel || '—'} voldeed aan de uitvoerregels.`}
          </p>
          <small>{(guardrails.checks || []).map((item) => String(item).replace(/_/g, ' ')).join(' · ')}</small>
        </section>
        <section>
          <span className="agent-decision-step">4 · Voorstel</span>
          <strong>{labelAction(final.actionType)} · {final.channel || '—'}</strong>
          <p>{final.requiresApproval ? 'De agent mag dit niet zelfstandig uitvoeren: menselijke goedkeuring is vereist.' : 'Geen menselijke goedkeuring vereist.'}</p>
          {ai.draftReason && <small>Draft: {ai.draftReason} · confidence {percent(ai.draftConfidence)}</small>}
        </section>
      </div>
      <p className="agent-decision-trace-note">Dit is een gestructureerde beslissamenvatting, geen interne chain-of-thought of ruwe modelprompt. De AI kan alleen kiezen uit kandidaat-acties die vooraf door de applicatie als veilig zijn toegestaan.</p>
    </details>
  );
}
